import { useContext, useState } from "react";
import { Loading } from "../../components/atoms";
import { api } from "../../helpers/api";
import { NotificationContext } from "../NotificationCTX/NotificationContext";
import { InterceptorContext } from "./InterceptorContext";

export function InterceptorProvider({ children }: { children: JSX.Element }) {
  const [loading, setLoading] = useState<boolean>(false);
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  api.interceptors.request.use(
    (config) => {
      setLoading(true);

      const exception = !(
        config.url?.includes("/login") ||
        config.url?.includes("/recuperarsenha") ||
        config.url?.includes("/vendadireta")
      );

      if (exception) {
        const token = localStorage.getItem("token") || "";
        config.headers!.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      setLoading(false);
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      setLoading(false);

      if (response.config.url?.includes("/login")) {
        localStorage.setItem("token", response.data.token);
      }
      return response;
    },
    (error) => {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          setType("danger");
          setTextAlert("Sessão expirada");
          setShow(true);

          localStorage.removeItem("token");
          window.location.replace("/auth/login");
        }
      } else if (error.request) {
        console.error("No response received:", error.request);
        setType("danger");
        setTextAlert("Erro de conexão. Por favor, tente novamente.");
        setShow(true);
      } else {
        console.error("Error setting up the request:", error.message);
        setType("danger");
        setTextAlert("Ocorreu um erro. Por favor, tente novamente.");
        setShow(true);
      }
      return Promise.reject(error);
    }
  );

  return (
    <InterceptorContext.Provider value={{}}>
      <Loading active={loading} />
      {children}
    </InterceptorContext.Provider>
  );
}
